import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Router } from 'react-router-dom';
import { push, replace, LOCATION_CHANGE } from 'react-router-redux';

export class ConnectedRouter extends Component {
  static propTypes = {
    store: PropTypes.object,
    history: PropTypes.object,
    children: PropTypes.node
  };

  static contextTypes = {
    store: PropTypes.object
  };

  handleLocationChange = location => {
    this.store.dispatch({
      type: LOCATION_CHANGE,
      payload: location
    });

    if(!(location.state && location.state.noscroll))
      window.scrollTo(0, 0);
  };

  componentWillMount() {
    const { store:propsStore, history } = this.props;
    this.store = propsStore || this.context.store;

    const redirect = this.redirectTo(history);

    if(redirect){
      this.store.dispatch(replace(redirect));
    } else {
      this.store.dispatch(push(history.location.pathname + history.location.search));
    }

    this.handleLocationChange(history.location);
  }

  componentDidMount() {
    const { history } = this.props;
    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory()
  }

  render() {
    return <Router {...this.props} />
  }

  redirectTo(history){
    if(history.location.pathname.startsWith('/Contact-us')){
      return '/contact';
    } else if(history.location.pathname.startsWith('/About-us')){
      return '/about';
    } else if(history.location.pathname.startsWith('/Applications')){
      return '/solutions';
    } else if(history.location.pathname.startsWith('/Downloads')){
      return '/support';
    } else if(history.location.pathname.startsWith('/News/All-news')){
      return '/news';
    } else if(history.location.pathname.startsWith('/News/Product-news')){
      return '/news';
    } else if(history.location.pathname.startsWith('/News/Exhibitions')){
      return '/news';
    } else if(history.location.pathname.match(/^(\/Products\/)\w+(\/led-aviation-obstruction-lights)/)){
      return '/solutions/led-aviation-obstruction-light';
    } else if(history.location.pathname.match(/^(\/Products\/)\w+(\/forensic-lights)/)){
      return '/solutions/forensic-lights';
    } else if(history.location.pathname.match(/^(\/Products\/)\w+(\/controllers-and-accessories)/)){
      return '/solutions/controllers-and-accessories';
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/redux/ConnectedRouter.js